import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const HomePage = () => {
  const { user } = useAuth();
  const [recentDocuments, setRecentDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRecentDocuments();
  }, []);

  const fetchRecentDocuments = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/documents', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const documents = await response.json();
        setRecentDocuments(documents.slice(0, 5)); // Show 5 most recent
      }
    } catch (error) {
      console.error('Error fetching documents:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{maxWidth: '1200px', margin: '0 auto', padding: '2rem'}}>
      {/* Welcome Header */}
      <div style={{
        background: 'linear-gradient(135deg, #2e7d32 0%, #4caf50 100%)',
        color: 'white',
        borderRadius: '12px',
        padding: '2rem',
        marginBottom: '2rem',
        textAlign: 'center'
      }}>
        <h1 style={{margin: '0 0 1rem 0', fontSize: '2.5rem'}}>
          Welcome to Gene™ Research
        </h1>
        <p style={{fontSize: '1.2rem', opacity: '0.9', margin: 0}}>
          Hello, {user?.name || user?.email}! Ready to discover your family history?
        </p>
      </div>

      {/* Quick Actions */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '1.5rem',
        marginBottom: '3rem'
      }}>
        <Link 
          to="/documents" 
          style={{
            background: 'white',
            border: '2px solid #2e7d32',
            borderRadius: '12px',
            padding: '2rem',
            textDecoration: 'none',
            color: 'inherit',
            transition: 'transform 0.3s, box-shadow 0.3s',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-4px)';
            e.target.style.boxShadow = '0 8px 25px rgba(46, 125, 50, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
          }}
        >
          <div style={{textAlign: 'center'}}>
            <div style={{fontSize: '3rem', marginBottom: '1rem'}}>📄</div>
            <h3 style={{color: '#2e7d32', marginBottom: '0.5rem'}}>Upload Documents</h3>
            <p style={{color: '#666', margin: 0}}>
              Upload and analyze genealogical documents with AI-powered OCR
            </p>
          </div>
        </Link>

        <Link 
          to="/gallery" 
          style={{
            background: 'white',
            border: '2px solid #1976d2',
            borderRadius: '12px',
            padding: '2rem',
            textDecoration: 'none',
            color: 'inherit',
            transition: 'transform 0.3s, box-shadow 0.3s',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-4px)';
            e.target.style.boxShadow = '0 8px 25px rgba(25, 118, 210, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
          }}
        >
          <div style={{textAlign: 'center'}}>
            <div style={{fontSize: '3rem', marginBottom: '1rem'}}>🖼️</div>
            <h3 style={{color: '#1976d2', marginBottom: '0.5rem'}}>Photo Gallery</h3>
            <p style={{color: '#666', margin: 0}}>
              Organize and explore your family photos and memories
            </p>
          </div>
        </Link>

        <Link 
          to="/resources" 
          style={{
            background: 'white',
            border: '2px solid #9c27b0',
            borderRadius: '12px',
            padding: '2rem',
            textDecoration: 'none',
            color: 'inherit',
            transition: 'transform 0.3s, box-shadow 0.3s',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-4px)';
            e.target.style.boxShadow = '0 8px 25px rgba(156, 39, 176, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
          }}
        >
          <div style={{textAlign: 'center'}}>
            <div style={{fontSize: '3rem', marginBottom: '1rem'}}>📚</div>
            <h3 style={{color: '#9c27b0', marginBottom: '0.5rem'}}>Research Resources</h3>
            <p style={{color: '#666', margin: 0}}>
              Access genealogy resources and research guides
            </p>
          </div>
        </Link>
      </div>

      {/* Gene AI Research Assistant */}
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '2rem',
        marginBottom: '2rem',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        border: '1px solid #e0e0e0'
      }}>
        <div style={{textAlign: 'center', marginBottom: '2rem'}}>
          <h2 style={{color: '#2e7d32', marginBottom: '1rem'}}>
            🧬 Gene AI Research Assistant
          </h2>
          <p style={{fontSize: '1.1rem', color: '#666', marginBottom: '2rem'}}>
            Get intelligent assistance with your genealogical research questions using advanced AI technology.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1.5rem'
        }}>
          <div style={{
            background: '#f8f9fa',
            borderRadius: '8px',
            padding: '1.5rem',
            textAlign: 'center'
          }}>
            <h4 style={{color: '#2e7d32', marginBottom: '1rem'}}>🔍 Research Guidance</h4>
            <p style={{color: '#666'}}>
              Get expert advice on research strategies and methodology
            </p>
          </div>

          <div style={{
            background: '#f8f9fa',
            borderRadius: '8px',
            padding: '1.5rem',
            textAlign: 'center'
          }}>
            <h4 style={{color: '#2e7d32', marginBottom: '1rem'}}>📜 Document Analysis</h4>
            <p style={{color: '#666'}}>
              Upload documents for AI-powered analysis and extraction
            </p>
          </div>

          <div style={{
            background: '#f8f9fa',
            borderRadius: '8px',
            padding: '1.5rem',
            textAlign: 'center'
          }}>
            <h4 style={{color: '#2e7d32', marginBottom: '1rem'}}>🌳 Family Connections</h4>
            <p style={{color: '#666'}}>
              Discover connections and organize your family tree
            </p>
          </div>
        </div>

        <div style={{textAlign: 'center', marginTop: '2rem'}}>
          <Link
            to="/documents"
            style={{
              background: '#2e7d32',
              color: 'white',
              border: 'none',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontSize: '1.1rem',
              fontWeight: '600',
              textDecoration: 'none',
              transition: 'background 0.3s',
              display: 'inline-block'
            }}
            onMouseEnter={(e) => e.target.style.background = '#1b5e20'}
            onMouseLeave={(e) => e.target.style.background = '#2e7d32'}
          >
            💬 Start Research Session
          </Link>
        </div>
      </div>

      {/* Recent Documents */}
      {!loading && recentDocuments.length > 0 && (
        <div style={{
          background: 'white',
          borderRadius: '12px',
          padding: '2rem',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          border: '1px solid #e0e0e0'
        }}>
          <h2 style={{color: '#333', marginBottom: '1.5rem'}}>📋 Recent Documents</h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '1rem'
          }}>
            {recentDocuments.map((doc, index) => (
              <div 
                key={index}
                style={{
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  padding: '1rem',
                  border: '1px solid #e0e0e0'
                }}
              >
                <h4 style={{margin: '0 0 0.5rem 0', color: '#2e7d32'}}>
                  📄 {doc.filename || 'Untitled Document'}
                </h4>
                <p style={{color: '#666', margin: '0', fontSize: '0.9rem'}}>
                  Uploaded: {new Date(doc.uploadDate).toLocaleDateString()}
                </p>
              </div>
            ))}
          </div>
          <div style={{textAlign: 'center', marginTop: '1.5rem'}}>
            <Link 
              to="/documents"
              style={{
                color: '#2e7d32',
                textDecoration: 'none',
                fontWeight: '600'
              }}
            >
              View All Documents →
            </Link>
          </div>
        </div>
      )}

      {/* Getting Started for New Users */}
      {!loading && recentDocuments.length === 0 && (
        <div style={{
          background: 'linear-gradient(135deg, #1565c0 0%, #1976d2 100%)',
          color: 'white',
          borderRadius: '12px',
          padding: '2rem',
          textAlign: 'center'
        }}>
          <h2 style={{marginBottom: '1rem'}}>🚀 Ready to Begin Your Family History Journey?</h2>
          <p style={{fontSize: '1.1rem', opacity: '0.9', marginBottom: '2rem'}}>
            Start by uploading a document or exploring research resources!
          </p>
          <div style={{display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap'}}>
            <Link 
              to="/documents"
              style={{
                background: 'white',
                color: '#1565c0',
                padding: '0.75rem 2rem',
                borderRadius: '50px',
                textDecoration: 'none',
                fontWeight: '600',
                transition: 'transform 0.3s'
              }}
              onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
            >
              📄 Upload Your First Document
            </Link>
            <Link 
              to="/tutorial"
              style={{
                background: 'rgba(255, 255, 255, 0.2)',
                color: 'white',
                padding: '0.75rem 2rem',
                borderRadius: '50px',
                textDecoration: 'none',
                fontWeight: '600',
                border: '2px solid white',
                transition: 'background 0.3s'
              }}
              onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.3)'}
              onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.2)'}
            >
              📚 View Tutorial
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
